import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ParcelHistoryDialogComponent } from '../../../../@theme/components/parcel-history-dialog/parcel-history-dialog.component';
import { DashboardBase } from '../dashboard.base';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { SignatureDialogComponent } from '../../../../@theme/components/signature-dialog/signature-dialog.component';

@Component({
  selector: 'ngx-detailrow',
  templateUrl: './detail-row.component.html',
  styleUrls: ['./detail-row.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'void',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class DetailRowComponent extends DashboardBase implements OnInit {
  @Input() element: any;

  ngOnInit(): void {}

  public getParcelStatusClass(parcelStatus: number): string {
    switch (parcelStatus) {
      case 1:
        return 'received';
      case 2:
        return 'scanned';
      case 3:
        return 'failed';
      case 4:
        return 'delivered';
      default:
        return 'received';
    }
  }

  public GetParcelHistories(ParcelID: number) {
    this._parcelhistoryService.initialiseParcel(ParcelID);
    const dialogRef = this.dialog.open(ParcelHistoryDialogComponent, {
      height: '700px',
      width: '1400px',
      data: { parcelId: ParcelID }
    });
  }
}
